export default __webpack_public_path__ + "static/line-with-gaps-d997a4f95ff83f7f252cd83d9f5ace63.png";